export default {"id":"1b319c1a","attrs":{"viewBox":"0 0 24 24","width":"24","height":"24"}}